/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ChildTrackingNumberVo
 */
export interface ChildTrackingNumberVo {
    /**
     * 运单ID
     * @type {number}
     * @memberof ChildTrackingNumberVo
     */
    waybillId?: number;
    /**
     * 运单号
     * @type {string}
     * @memberof ChildTrackingNumberVo
     */
    trackingNumber?: string;
}

/**
 * Check if a given object implements the ChildTrackingNumberVo interface.
 */
export function instanceOfChildTrackingNumberVo(value: object): value is ChildTrackingNumberVo {
    return true;
}

export function ChildTrackingNumberVoFromJSON(json: any): ChildTrackingNumberVo {
    return ChildTrackingNumberVoFromJSONTyped(json, false);
}

export function ChildTrackingNumberVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ChildTrackingNumberVo {
    if (json == null) {
        return json;
    }
    return {
        
        'waybillId': json['waybillId'] == null ? undefined : json['waybillId'],
        'trackingNumber': json['trackingNumber'] == null ? undefined : json['trackingNumber'],
    };
}

export function ChildTrackingNumberVoToJSON(json: any): ChildTrackingNumberVo {
    return ChildTrackingNumberVoToJSONTyped(json, false);
}

export function ChildTrackingNumberVoToJSONTyped(value?: ChildTrackingNumberVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'waybillId': value['waybillId'],
        'trackingNumber': value['trackingNumber'],
    };
}

